import { render, staticRenderFns } from "./StudentAge.vue?vue&type=template&id=1afd5e84&"
import script from "./StudentAge.js?vue&type=script&lang=js&"
export * from "./StudentAge.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports